import { z } from 'zod';

export const ShortcutTeamIdsSchema = z.array(z.string().uuid()).max(20)
  .refine(ids => new Set(ids).size === ids.length, 'Select each Shortcut team once');
export type ShortcutTeamIds = z.infer<typeof ShortcutTeamIdsSchema>;


export const ShortcutStoryEvidenceSchema = z.object({
  id: z.string().min(1), storyId: z.string().regex(/^\d+$/), title: z.string(), status: z.string(),
  teamId: z.string().uuid(), ownerIds: z.array(z.string().uuid()), collectedAt: z.string().datetime({ offset: true }),
  content: z.string(),
});
export type ShortcutStoryEvidence = z.infer<typeof ShortcutStoryEvidenceSchema>;
